/* __next_internal_client_entry_do_not_use__ HeaderSearch auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { topNavEvent } from "@faire/retailer-visitor-shared/components/Header/Events";
import { TopSearch } from "@faire/retailer-visitor-shared/components/TopSearch/TopSearch";
import { home } from "@faire/retailer-visitor-shared/paths/index";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { isRobot } from "@faire/web--source/common/user-agent/isRobot";
import { matchPathWithLocale } from "@faire/web--source/ui/routing/react-utils";
import React, { useCallback } from "react";
export var HeaderSearch = function(param) {
    var onFocus = param.onFocus, inputId = param.inputId, inputDataTestId = param.inputDataTestId, onBlur = param.onBlur;
    // This function reference must be stable for page scrolling
    var headerSearchFocus = useCallback(function(element, isOnToggle) {
        topNavEvent("search");
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(element, isOnToggle);
    }, [
        onFocus
    ]);
    var isOnHome = matchPathWithLocale(getCurrentPath().pathname, home());
    var shouldAutofocus = isRobot() && isOnHome;
    return /*#__PURE__*/ _jsx("div", {
        style: {
            flex: "1"
        },
        children: /*#__PURE__*/ _jsx(TopSearch, {
            inputId: inputId,
            inputDataTestId: inputDataTestId,
            autofocus: shouldAutofocus,
            onFocus: headerSearchFocus,
            onBlur: onBlur
        })
    });
};
